import axios from "axios";

const baseURL = "https://subscription.shipday.com"

export default axios.create({
    baseURL: baseURL
});
